/**
 * The scale of the pages that shrink what they print (Packing, Platings): a css zoom
 * kept in the url as ?scale=, so a bookmark or a print macro replays it. It is a
 * fraction of actual size: 1 prints at actual size, 0.6 shrinks everything to 60%.
 *
 * Values outside the range are refused rather than applied. A packing sheet asked for
 * at scale=60 (meant as 60%) made the server's chrome grow by 100 MB/s until api2 was
 * swapping and every api request stalled (2026-10-15).
 */
export const PRINT_SCALE_RANGE = {min: 0.1, max: 1.5};

export function isPrintScale(value) {
  return typeof value === 'number' && Number.isFinite(value)
    && value >= PRINT_SCALE_RANGE.min && value <= PRINT_SCALE_RANGE.max;
}

/** the scale a page starts with from its url: actual size unless the url carries a usable one */
export function printScaleFromUrl(value) {
  const scale = Number(value);
  return isPrintScale(scale) ? scale : 1;
}

/** what was typed when it cannot be used as a scale, else null (an emptied field is not a value) */
export function rejectedPrintScale(value) {
  if (value === '' || value === null || value === undefined) {
    return null;
  }
  return isPrintScale(Number(value)) ? null : value;
}
